
<style>
    [v-cloak] {
        display: none;
    }
</style>

<template>
  <div class="grid">
    <div class="col-3">
      <Dropdown v-model="QuestionType" :options="QuestionTypes.filter(x => x.typeId == 1)" optionLabel="typeName" optionValue="typeId" placeholder="Select Question Type" @change="SetOptions(false)" class="mt-3 mr-2 ml-2" />

      <Button label="Save Changes" icon="pi pi-check" class="mt-3 mr-2 ml-2 p-button-success" iconPos="right" :disabled="DisableSave" @click="submit" :loading="isSaving" />

      <!--<Button label="Reset Changes" icon="pi pi-cog" class="mt-3 mr-2 ml-2 p-button-info" iconPos="right" @click="ResetOptions" :loading="isSaving" />-->

      <Button label="Close/Cancel" icon="pi pi-ban" class="mt-3 mr-2 ml-2 p-button-danger" iconPos="right" @click="SetOriginalValues" />

      <!--<InputSwitch v-model="RankOptions" @change="SetOptions(true)" v-if="QuestionType != 3" class="ml-2" />-->
    </div>


    <!--Show if there are no options selected-->
    <div class="col-12 ml-2 pt-0" v-if="ShowOptions && QuestionOptions.length == 0 && QuestionType != 3" v-cloak>
      <Card>
        <template #content>
          <Message severity="info">
            <Button label="Add Options" icon="pi pi-plus" class=" mr-2 ml-2 p-button-info" iconPos="right" @click="SetOptions(true)" v-on:click="SetOptions(true)" />
          </Message>
        </template>
      </Card>
    </div>


    <!--If there are exisitng options show and allow to edit-->
    <div class="col-12 m-3 p-2" v-if="ShowOptions && QuestionOptions.length != 0">
      <h6>  Question Options</h6>
      <InputSwitch v-model="EditOptions.EditingOptions" @change="SetOptions(true)" v-if="QuestionType != 1 && QuestionType != 3" class="ml-3 mr-5" name="EditMode" />

      <label for="EditMode" v-if="QuestionType != 1 && QuestionType != 3">Edit Mode</label>
      <Button label="Add New Option" icon="pi pi-cog" class="mt-3 mr-2 ml-2 p-button-info" iconPos="right" @click="AddNewOption" v-if="QuestionType != 1 && QuestionType != 3 && EditOptions.EditingOptions" />

      <div v-if="!EditOptions.EditingOptions">
        <Tag v-for="o in QuestionOptions" :key="o.OptionOrder" class="ml-1 mb-1" :style="{'background-color':SetOptionColor(o.OptionValue)}" @dblclick="o.Edit = true">
          {{ o.OptionDescription}}
        </Tag>
      </div>
    </div>

    <div class="col-12 mb-2" v-if="EditOptions.EditingOptions">
      <Card>
        <template #header>
          <h6>  Question Options</h6>
        </template>
        <template #content>
          <div class="col-4" v-for="(o, index) in QuestionOptions" :key="o.OptionOrder">
            <InputText type="text" v-model="o.OptionDescription" class="p-2" />
            <Button icon="pi pi-trash" class="p-button-rounded p-button-error ml-1" v-on:click="RemoveQuestionOption(index)" v-if="QuestionOptions.length != 1" />
          </div>
        </template>
      </Card>
    </div>

    <div class="col-12" v-if="ShowSetQuestionOptions">
      <Card class="mt-0">
        <template #header>
          <h6 align="center">
            <Button icon="pi pi-plus-circle" class="p-button-primary ml-1 mt-3 p-button-sm" v-if="!RankOptions" style="cursor:pointer" v-on:click="AddOption" :label="SetQuestionOptionText" />
          </h6>
        </template>
        <template #content>


          <div class="flex" v-if="ShowSetQuestionOptions">
            <div class="col-2" v-for="(o, index) in SetQuestionOptions" :key="o.OptionOrder">
              <span class="p-input-icon-left m-3">
                <i class="pi pi-star-fill" :style="{'color':SetOptionColor(o.OptionValue)}" />
                <InputText type="text" v-model="o.OptionDescription" class="w-full mr-3 ml-3 p-inputtext-sm" :style="{'color':SetOptionColor(o.OptionValue)}" />
              </span>
              <Button v-show="!RankOptions" v-on:click="RemoveOption(index)" label="delete"/>

            </div>


            <!--<v-text-field dense
                  clerable
                  v-model="o.OptionDescription"
                  required
                  rounded
                  :color="SetOptionColor(o.OptionValue)"
                  :label="o.OptionOrder.toString()"
                  :error-messages="errors"
                  outlined>
      <v-icon slot="prepend"
              :color="SetOptionColor(o.OptionValue)" v-if="RankOptions" style="cursor:pointer" v-on:click="RemoveOption(index)">
        mdi-progress-question
      </v-icon>

      <v-icon slot="prepend"
              color="red" v-if="!RankOptions" style="cursor:pointer" v-on:click="RemoveOption(index)">
        mdi-delete
      </v-icon>
    </v-text-field>-->

          </div>
        </template>
        <!--<v-row v-if="(!SetQuestionOptions) || SetQuestionOptions.length == 0">
        <div class="col-md-12">
          <v-alert color="primary"
                   type="warning"><b>No Options Added</b></v-alert>
        </div>
      </v-row>-->
      </Card>
    </div>

  </div>





    <!--<div class="row d-flex mt-0" v-if="ShowSetQuestionOptions">
        <div class="col-md-12">
            <v-card class="mt-0">
                <div class="col-md-12 mt-0">
                    <v-subheader align="center">
                        {{SetQuestionOptionText}}  <v-icon class="ml-1"
                                                           color="primary"
                                                           v-if="!RankOptions"
                                                           style="cursor:pointer"
                                                           v-on:click="AddOption">
                            mdi-plus-box-multiple
                        </v-icon>
                    </v-subheader>
                    <v-row>
                        <div v-for="(o, index) in SetQuestionOptions"
                             :key="o.OptionOrder">
                            <v-col>
                                <validation-observer ref="observer">
                                    <validation-provider v-slot="{ errors }" name="Option" rules="required">
                                        <v-text-field dense
                                                      clerable
                                                      v-model="o.OptionDescription"
                                                      required
                                                      rounded
                                                      :color="SetOptionColor(o.OptionValue)"
                                                      :label="o.OptionOrder.toString()"
                                                      :error-messages="errors"
                                                      outlined>
                                            <v-icon slot="prepend"
                                                    :color="SetOptionColor(o.OptionValue)" v-if="RankOptions" style="cursor:pointer" v-on:click="RemoveOption(index)">
                                                mdi-progress-question
                                            </v-icon>

                                            <v-icon slot="prepend"
                                                    color="red" v-if="!RankOptions" style="cursor:pointer" v-on:click="RemoveOption(index)">
                                                mdi-delete
                                            </v-icon>
                                        </v-text-field>
                                    </validation-provider>
                                </validation-observer>
                            </v-col>
                        </div>
                    </v-row>

                    <v-row v-if="(!SetQuestionOptions) || SetQuestionOptions.length == 0">
                        <div class="col-md-12">
                            <v-alert color="primary"
                                     type="warning"><b>No Options Added</b></v-alert>
                        </div>
                    </v-row>
                </div>
                </v-card>
            </div>
        </div>
    <v-snackbar :timeout="1200"
                rounded top eager
                v-model="OptionsSuccessSnack"
                color="success"
                shaped>
        <v-icon>mdi-text-box-check</v-icon>  {{OptionsSuccessMessage}}
    </v-snackbar>
    <v-snackbar v-model="OptionsErrorSnack"
                color="error" rounded top right eager>
        {{ OptionsErrorMessage }}
    </v-snackbar>-->

</template>

<style>
  .p-button{
    cursor:pointer !important;
  }
</style>

<script>

   import useVuelidate from '@vuelidate/core'
   import { required, email, helpers } from '@vuelidate/validators'

   import Button from 'primevue/button';
   import { reactive, computed } from 'vue'
   import { useToast } from "primevue/usetoast";
   import InputText from 'primevue/inputtext';
  import Dropdown from 'primevue/dropdown';
    import Card from 'primevue/card';
  import Tag from 'primevue/tag';
    import InputSwitch from 'primevue/inputswitch';
  import Message from 'primevue/message';


    export default {
        name: 'QuestionDetail',
        components: {
          Message,
          Button,
          Card,
      
          InputText,
          Dropdown,
          InputSwitch,
          Tag
    },
    setup() {
      const toast = useToast();
      const isStrongPassword = helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/)

      const state = reactive({
        FirstName: '',
        LastName: '',
        Email: '',
        Password: ''
      })
      const rules = computed(() => {
        return {
          Email: { required: helpers.withMessage("Email Is Required To Start", required), email: helpers.withMessage("Input Must Be A Valid Email Address", email) },
          FirstName: { required: helpers.withMessage("Please Enter Your First Name", required) },
          LastName: { required: helpers.withMessage("Please Enter Your Last Name", required) },
          Password: { required: helpers.withMessage("You Must Specify A Password", required), isStrongPassword: helpers.withMessage("Password Must Meet The Strong Specifications", isStrongPassword) },
        }
      });

      const v$ = useVuelidate(rules, state)
      return { state, v$, toast }
    },
        data: () => ({
            Icon: '',
            Color: '',
            OriginalQuestionType: '',
            OriginalRank: '',
            QuestionTypes: [],
            QuestionType: null,
            OptionsSuccessSnack: false,
            OptionsErrorSnack: false,
            OptionsErrorMessage: '',
            OptionsSuccessMessage: '',
            QuestionOptions: [],
            OriginalQuestionOptions: [],
            EditOptions: {
                IsChangingQuestionType: false,
                IsChangingRanking: false,
                EditingOptions: false,
                IsAddingOptions: false
            },
            DeleteIds: [],
            SetQuestionOptions: [],
            RankOptions: '',
            SetQuestionOptionText: '',
            OptionDefaults: [],
            isSaving: false,
            Axios: '',
            UniqueIdentifier: '',
            DisableSave: true,
            DisableReset: true,
            ShowOptions: false,
            ShowSetQuestionOptions: false,
            ContainerHeight: ''
        }),
        created() {
            var self = this;
            this.QuestionTypes = this.params.QuestionTypes;
            this.OriginalQuestionType = this.params.data.questionType;
            this.QuestionType = this.params.data.questionType;
            this.Icon = 'Detail Question Options Here';
            this.OptionDefaults = this.params.OptionDefaults;
            this.UniqueIdentifier = 'child_' + this.params.data.id;

        
            var rank = false;

            if (this.params.data.isRanked == '' || this.params.data.isRanked == null) {
                rank = false;
            }
            else {
                rank = this.params.data.isRanked;
            }

            this.OriginalRank = rank;
            this.RankOptions = rank;

            this.$http.post("Questions/GetQuestionOptions", { QuestionIds: [this.params.data.id] }).then(function (response) {
              if (response.data.success) {

                    var optionOrder = 1;
                    for (var i = 0; i < response.data.questionOptions.length; i++) {

                        var record = response.data.questionOptions[i];

                        var questionOption = {
                            OptionValue: record.optionValue == null ? record.defaultOptionValue : record.optionValue,
                            OptionOrder: record.optionOrder == null ? record.defaultOptionOrder : record.optionOrder == null ? optionOrder : record.optionOrder,
                            OptionDescription: record.optionDescription == null ? record.defaultOptionDescription : record.optionDescription,
                            QuestionTypeId: record.questionTypeId,
                            QuestionId: self.params.data.id,
                            QuestionOptionId: record.questionOptionId,
                            UsesDefaultOptions: record.usesDefaultOptions,
                            DefaultOptionId: record.defaultOptionId,
                            IsOptOut: record.isOptOut,
                            IsCommentTriggering: record.isCommentTriggering
                        }
                      self.QuestionOptions.push(questionOption);
                      optionOrder += 1;
                    }

                    self.OriginalQuestionOptions = self.QuestionOptions.map(x => x);
                    self.ShowOptions = true;
                }
            })
        },
        watch: {
            RankOptions() {
                if (this.RankOptions != this.OriginalRank || this.QuestionType != this.OriginalQuestionType || this.EditOptions.IsAddingOptions)
                    this.DisableSave = false;
                else {
                    this.DisableSave = true;
                }
            },
            EditOptions: {
                handler() {
                    if (this.EditOptions.EditingOptions)
                        this.DisableSave = false
                    else
                        this.DisableSave = false
                },
                deep: true
            }
        },
        computed: {
            IsValid() {
                var valid = true;

                if (this.QuestionType == 1 || this.QuestionType == 3)
                    return true;

                if (this.$refs.observer) {
                    // debugger;  eslint-disable-line no-debugger
                    for (var i = 0; i < this.$refs.observer.length; i++) {
                        valid = this.$refs.observer[i].validate()
                    }
                }
                return valid;
            },
        },
        methods: {
          SetOptions(rankchange) {
                /*If Single Select*/
                if (this.QuestionType == 1) {
                    this.ShowOptions = true;
                    this.ShowSetQuestionOptions = false;

                    if (this.OriginalQuestionType == 1) {

                        if (this.OriginalQuestionOptions.length == 0) {

                            var standardNewQuestionOptions = new Array();
                            var setNewQuestionsOptions = new Array();

                            for (var v = 0; v < this.OptionDefaults.filter(c => c.questionTypeId == 1).length; v++) {

                                var newRecord = this.OptionDefaults[v];

                                var newQuestionOption = {
                                    OptionValue: newRecord.optionValue,
                                    OptionOrder: newRecord.optionOrder,
                                    OptionDescription: newRecord.optionDescription,
                                    QuestionTypeId: 1,
                                    QuestionId: this.params.data.id,
                                    QuestionOptionId: null,
                                    UsesDefaultOptions: true,
                                    DefaultOptionId: newRecord.defaultId
                                }

                                standardNewQuestionOptions.push(newQuestionOption);

                                setNewQuestionsOptions.push({
                                    OptionValue: null,
                                    OptionOrder: null,
                                    OptionDescription: null,
                                    QuestionTypeId: 1,
                                    QuestionId: this.params.data.id,
                                    QuestionOptionId: null,
                                    UsesDefaultOptions: true,
                                    DefaultOptionId: newRecord.defaultId
                                })
                            }

                            this.SetQuestionOptions = setNewQuestionsOptions;
                            this.QuestionOptions = standardNewQuestionOptions;
                            this.DisableSave = false;
                            this.ShowSetQuestionOptions = false;
                        }
                        else {
                            this.QuestionOptions = this.OriginalQuestionOptions;
                        }


                        if (!rankchange) {
                            if (this.OriginalRank != this.RankOptions) {
                                this.RankOptions = this.OriginalRank;
                                this.DisableSave = false;
                            }
                            else {
                                this.DisableSave = true;
                            }
                        }

                        return false;
                    }

                    if (this.OriginalQuestionType != 1) {
                        var standardQuestionOptions = new Array();
                        var setQuestionsOptions = new Array();

                        for (var i = 0; i < this.OptionDefaults.filter(c => c.questionTypeId == 1).length; i++) {

                            var record = this.OptionDefaults[i];

                            var questionOption = {
                                OptionValue: record.optionValue,
                                OptionOrder: record.optionOrder,
                                OptionDescription: record.optionDescription,
                                QuestionTypeId: 1,
                                QuestionId: this.params.data.id,
                                QuestionOptionId: null,
                                UsesDefaultOptions: true,
                                DefaultOptionId: record.defaultId
                            }

                            standardQuestionOptions.push(questionOption);

                            setQuestionsOptions.push({
                                OptionValue: null,
                                OptionOrder: null,
                                OptionDescription: null,
                                QuestionTypeId: 1,
                                QuestionId: this.params.data.id,
                                QuestionOptionId: null,
                                UsesDefaultOptions: true,
                                DefaultOptionId: record.defaultId
                            })
                        }

                        this.SetQuestionOptions = setQuestionsOptions;
                        this.QuestionOptions = standardQuestionOptions;
                        this.DisableSave = false;
                    }
                }

                /*If Open Ended*/
                if (this.QuestionType == 3) {
                    this.QuestionOptions = []

                    if (this.QuestionType != this.OriginalQuestionType) {
                        this.DisableSave = false;
                    }
                    else {
                        this.DisableSave = true;
                    }

                    this.ShowOptions = false;
                    this.SetQuestionOptions = [];
                    this.ShowSetQuestionOptions = false;
                }


                /*If its Option Single Select*/
                if (this.QuestionType == 4 || this.QuestionType == 2) {

                    if (this.OriginalQuestionType == this.QuestionType && this.QuestionOptions.length != 0 && !this.RankOptions) {
                        this.QuestionOptions = this.OriginalQuestionOptions;
                        this.ShowOptions = true;
                        this.DisableSave = true;
                        return false;
                    }

                    this.SetQuestionOptions = [];
                    this.ShowSetQuestionOptions = true;
                    this.QuestionOptions = [];
                    this.ShowOptions = false;


                    if (this.RankOptions) {

                        this.SetQuestionOptionText = 'Set Question Options'

                        var questionOptions = this.OptionDefaults.filter(x => x.questionTypeId == this.QuestionType)[0]

                        var optionOrder = 0;

                        for (var q = 0; q < questionOptions.optionsThreshHold; q++) {
                            this.SetQuestionOptions.push({
                                OptionValue: this.OptionDefaults[q].optionValue,
                                OptionOrder: optionOrder += 1,
                                OptionDescription: null,
                                QuestionTypeId: this.QuestionType,
                                QuestionId: this.params.data.id,
                                QuestionOptionId: null,
                                UsesDefaultOptions: false,
                                DefaultOptionId: null
                            })
                        }
                    }
                    else {
                        this.SetQuestionOptionText = 'Add Question Options'
                        this.SetQuestionOptions.push({
                            OptionValue: 0,
                            OptionOrder: 1,
                            OptionDescription: null,
                            QuestionTypeId: this.QuestionType,
                            QuestionId: this.params.data.id,
                            QuestionOptionId: null,
                            UsesDefaultOptions: false,
                            DefaultOptionId: null
                        })
                    }

                    this.EditOptions.IsAddingOptions = true;
                    this.DisableSave = false;
                }
            },
            ResetOptions() {
                this.QuestionOptions = this.OriginalQuestionOptions.map(x => x)
                this.RankOptions = this.OriginalRank;
                this.QuestionType = this.params.data.questionType;

                if (this.QuestionOptions.length != 0)
                    this.ShowOptions = true;

                if (this.EditOptions.EditingOptions || this.EditOptions.IsAddingOptions)
                    this.SetQuestionOptions = [];
                this.ShowSetQuestionOptions = false;
                this.EditOptions.EditingOptions = false;
            },
            AddOption() {
                var optionOrder = this.SetQuestionOptions.length + 1;

                this.SetQuestionOptions.push({
                    OptionValue: 0,
                    OptionOrder: optionOrder,
                    OptionDescription: null,
                    QuestionTypeId: this.QuestionType,
                    QuestionId: this.params.data.id,
                    QuestionOptionId: null,
                    UsesDefaultOptions: false,
                    DefaultOptionId: null
                })
            },
            AddNewOption() {
                var optionOrder = this.QuestionOptions.length + 1;

                this.QuestionOptions.push({
                    OptionValue: 0,
                    OptionOrder: optionOrder,
                    OptionDescription: null,
                    QuestionTypeId: this.QuestionType,
                    QuestionId: this.params.data.id,
                    QuestionOptionId: null,
                    UsesDefaultOptions: false,
                    DefaultOptionId: null
                })
            },

            SetOriginalValues() {
                
                var node = this.params.api.getRowNode(this.params.data.id);
                node.setExpanded(false);
            },
            RemoveOption(index) {
                this.$delete(this.SetQuestionOptions, index)

                var order = 0;

                for (var i = 0; i < this.SetQuestionOptions.length; i++) {

                    order += 1;
                    this.SetQuestionOptions[i].OptionOrder = order;
                }
            },
            RemoveQuestionOption(index) {
                var deleteId = this.QuestionOptions[index].questionOptionId;
                this.DeleteIds.push(deleteId);

                this.$delete(this.QuestionOptions, index)
                var order = 0;

                for (var i = 0; i < this.QuestionOptions.length; i++) {

                    order += 1;
                    this.QuestionOptions[i].OptionOrder = order;
                }
            },
            SetOptionColor(OptionValue) {
                var color = "rgb(209, 131, 15)";
                if (this.RankOptions) {

                    if (OptionValue == 5) {
                      color = "#4CAF50"
                    }
                    if (OptionValue == 4) {
                      color = "#A5D6A7";
                    }
                    if (OptionValue == 3) {
                      color = "#F57C00"
                    }
                    if (OptionValue == 2) {
                      color = "#EF5350"
                    }
                    if (OptionValue == 1) {
                      color = "#C62828"
                    }
                }

                return color;
            },
            async submit() {
                var self = this;

                var valid = true;

                if (this.$refs.observer) {
                    // debugger;  eslint-disable-line no-debugger
                    for (var i = 0; i < this.$refs.observer.length; i++) {
                        valid = await this.$refs.observer[i].validate()
                    }
                }

                if (valid) {
                    self.isSaving = true;

                    if (this.EditOptions.EditingOptions)
                        this.SetQuestionOptions = this.QuestionOptions.map(x => x);

                    await this.$http.put('/Questions/UpdateOptions', {
                        QuestionType: this.QuestionType,
                        QuestionId: this.params.data.id,
                        UpdateQuestionOptions: this.SetQuestionOptions,
                        IsRanked: this.QuestionType == 3 ? false : this.RankOptions
                    }).then(function (response) {
                        if (response.data.success) {

                            self.isSaving = false;
                            var question = response.data.questions[0];

                            self.OptionsSuccessMessage = 'Question Successfully Updated';
                            self.OptionsSuccessSnack = true;

                            self.params.node.data.questionType = question.questionType;
                            self.params.node.data.typeName = question.typeName;
                            self.params.node.data.isRanked = question.isRanked

                            self.params.api.refreshCells({
                                force: true
                            });

                            if (self.EditOptions.EditingOptions)
                              self.EditOptions.EditingOptions = false;

                            self.OriginalRank = self.RankOptions;
                            self.OriginalQuestionOptions = self.QuestionOptions.map(x => x);
                            self.ShowSetQuestionOptions = false;
                            self.ShowOptions = true;
                            self.EditOptions.IsAddingOptions = false;

                        }
                        else {
                            self.isSaving = false;
                            self.OptionsErrorMessage = 'Error Updating Questions';
                            self.OptionsErrorSnack = true;
                        }
                    })
                }
            },
            clear() {
                // you can use this method to clear login form
                this.$refs.observer.reset()
            }
        }
    };
</script>